import { initializeAgent as coreInit } from '@grafana/agent-core';
import { makeCoreConfig } from './config';
export function initializeAgent(config) {
    const coreConfig = makeCoreConfig(config);
    return coreInit(coreConfig);
}
//# sourceMappingURL=initialize.js.map